import React from "react";

type DropdownIconProps = React.SVGProps<SVGSVGElement>;

export const DropdownIcon = ({
  width = 20,
  height = 20,
  ...props
}: DropdownIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M14.1667 8.33333L10 12.5L5.83337 8.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
  
);

export default DropdownIcon;
